import { useEffect } from 'react';

import Beforeunload from '@eGroupTeam/utils/Beforeunload';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import headimg from 'static/images/classroom.jpg';
import useHasLogined from 'utils/useHasLogined';

import {
    Box,
    CircularProgress,
    Container,
    TextField,
    Typography,
} from '@eGroupTeam/material';
import Center from '@eGroupTeam/material-layout/Center';
import Button from '@eGroupTeam/material/Button';
import RatioImage from '@eGroupTeam/material/RatioImage';
import { Formik } from 'formik';
import { Redirect } from 'react-router-dom';
import { UrlParams } from 'types';
import SurveyForm from './SurveyForm';
import parseResponseList from './parseResponseList';
import {
    fetchGetSurveyQuestions,
    fetchPostSurveyResponses,
    getIsPosting,
    getSurveyQuestionProperties,
    getSurveyQuestions,
} from './redux';

const Survey = ({ survey }) => {
  const dispatch = useDispatch();
  const { surveyId } = useParams<UrlParams>();
  const [cookies] = useCookies(['uid']);
  const isPosting = useSelector(getIsPosting);
  const surveyQuestions = useSelector(getSurveyQuestions);
  const questionProperties = useSelector(getSurveyQuestionProperties);
  const hasLogin = useHasLogined();

  const clientMessage = survey && survey.get && survey.get('clientMessage');
  const NOT_ELIGIBLE = [
    '非本場活動參與者',
    '非本場活動受邀者',
    '此問卷為活動問卷，查無您報名資料',
  ];
  const shouldRedirectToPhone = NOT_ELIGIBLE.includes(clientMessage);

  useEffect(() => {
    if (survey && !shouldRedirectToPhone) {
      dispatch(
        fetchGetSurveyQuestions({
          surveyId,
        })
      );
    }
  }, [dispatch, surveyId, survey, shouldRedirectToPhone]);

  useEffect(() => {
    if (survey && surveyQuestions) {
      Beforeunload.block();
    }
  }, [survey, surveyQuestions]);

  const handleSubmit = (values) => {
    dispatch(
      fetchPostSurveyResponses({
        surveyId,
        responseList: parseResponseList(values, questionProperties.toJS()),
      })
    );
    Beforeunload.unblock();
  };

  /**
   * uid is userId it'll get when user filled phone
   */
  if (shouldRedirectToPhone || (!cookies.uid && !hasLogin)) {
    return <Redirect to={`/phone-fill-survey?surveyId=${surveyId}`} />;
  }

  if (clientMessage === '非進行中的問卷') {
    return (
      <Center>
        <Typography>非進行中的問卷</Typography>
      </Center>
    );
  }

  if (!survey || !surveyQuestions) {
    return (
      <Center>
        <CircularProgress />
      </Center>
    );
  }

  return (
    <Formik initialValues={{}} onSubmit={handleSubmit}>
      {(props) => (
        <Container>
          <RatioImage
            src={headimg}
            fit="cover"
            ratio="16:5"
            alt="Photo by Ferran Feixas on Unsplash"
          />
          <Box my={2}>
            <Typography
              variant="h5"
              gutterBottom={survey.has('surveyDescription')}
            >
              {survey.get('surveyName')}
            </Typography>
            {survey.has('surveyDescription') && (
              <TextField
                multiline
                value={survey.get('surveyDescription')}
                fullWidth
                disabled
                InputProps={{ style: { color: '#000' } }}
              />
            )}
          </Box>
          <SurveyForm {...props} />
          <Box py={3} textAlign="right">
            <Button
              loading={isPosting}
              type="submit"
              variant="contained"
              color="primary"
              onClick={props.submitForm}
              fullWidth
              disableElevation
            >
              送出
            </Button>
          </Box>
        </Container>
      )}
    </Formik>
  );
};

export default Survey;
